import React, { useState } from 'react';
import { View, TouchableOpacity, Text, StyleSheet, FlatList } from 'react-native';
import {
  GAME_TYPE_ARRANGEMENT,
  GAME_TYPES_CONFIG,
  GAME_TYPES_TYPE,
  operandText,
} from '../../../constants/constants';
import ChevronDown from 'react-native-vector-icons/FontAwesome';
import { color } from 'react-native-reanimated';

export type TGameDropDownButtonOblongProps = {
  gameSelected: GAME_TYPES_TYPE | 'All';
  setGameSelected: (game: GAME_TYPES_TYPE | 'All') => void;
  setShowDropdown: () => void;
  hideArrow?: boolean;
  color?: string;
};

type TOblongText = {
  label: string;
  hideArrow?: boolean;
};

const OblongText = ({ label, hideArrow }: TOblongText) => {
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      <Text style={styles.textDropdown}>{label}</Text>
      {!hideArrow && <ChevronDown name="chevron-down" size={14} style={styles.dropdownArrow} />}
    </View>
  );
};

export default function GameDropDownButtonOblong({
  gameSelected,
  hideArrow,
  setShowDropdown,
  color = '#FEDD88',
}: TGameDropDownButtonOblongProps) {
  return (
    <View style={{ position: 'relative' }}>
      {/* Main Button */}
      <TouchableOpacity
        onPress={() => setShowDropdown()}
        style={[styles.buttonDropdown, { backgroundColor: color }]}
      >
        <OblongText
          hideArrow={hideArrow}
          label={
            gameSelected === 'All'
              ? 'All'
              : `${operandText[GAME_TYPES_CONFIG[gameSelected].operation]} ${
                  GAME_TYPES_CONFIG[gameSelected].name
                }`
          }
        />
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  textDropdown: {
    fontFamily: 'Secular One',
    fontSize: 14,
    fontWeight: '400',
    color: '#333333',
  },
  buttonDropdown: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    height: 36,
    paddingHorizontal: 10,
    borderRadius: 45,
  },
  dropdownArrow: {
    marginLeft: 5,
    color: '#00000059',
  },
  dropdownContainer: {
    marginTop: 5,
    padding: 6,
    backgroundColor: '#FFF9E6',
    borderRadius: 12,
    shadowColor: '#000',
    shadowOpacity: 0.05,
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 4,
    elevation: 2,
    width: 220,
    position: 'absolute',
    maxHeight: 255,
    top: 30,
    borderWidth: 2,
    borderColor: '#FFCF53',
  },
  dropdownItem: {
    paddingVertical: 6,
    paddingHorizontal: 12,
    marginVertical: 4,
    borderRadius: 45,
    backgroundColor: '#FEDD88',
    alignSelf: 'flex-start',
  },
  dropdownItemText: {
    fontFamily: 'Secular One',
    fontSize: 14,
    color: '#333333',
  },
});
